// Returns `value` as it was on the last render where `active` was false, for as
// long as `active` stays true (KAN-768). A drawer's Save button must keep the
// words the user TAPPED ("Guardar Cambios") through the working/success beat and
// the exit slide, even when the parent re-derives create/edit mode while closing.
import { useRef } from 'react';

export default function useLatchedWhile(value, active) {
  const ref = useRef(value);
  if (!active) ref.current = value;
  return ref.current;
}
